@if ($backgroundImageUrl(); as backgroundImageUrl) {
    <div class="loading-backdrop" [style]="{'background-image': 'url(' + backgroundImageUrl + ')'}"></div>
}
@if ($showSpinner() && !$inlinedSvg.isLoading()) {
    <div class="loading-content">
        <ng-content select="[cm-text-top]"> </ng-content>
        @if ($inlinedSvg.value()) {
            <div id="animation" part="cm-loading-spinner" [innerHtml]="$inlinedSvg.value()"></div>
        } @else {
            <cm-loading-spinner-icon></cm-loading-spinner-icon>
        }
        <ng-content select="[cm-text-bottom]"> </ng-content>
    </div>
}
